import {
  BRIEF_AUDIENCE_META,
  type BriefAudience,
} from '../../../shared/briefFields';
import { AUDIENCE_ICONS } from './audienceIcons';

/**
 * The audience chip, React side. Shares its `.brief-aud` classes with the
 * plain-DOM chip in the BriefField node view (see src/client/styles.css), so
 * the drawer and the document agree pixel for pixel.
 *
 * `onClick` makes it a button that flips the audience; without one it renders
 * as a static span.
 */
export default function AudienceChip({
  audience,
  onClick,
  title,
}: {
  audience: BriefAudience;
  onClick?: () => void;
  title?: string;
}) {
  const meta = BRIEF_AUDIENCE_META[audience];
  const className = `brief-aud brief-aud--${audience}`;
  const inner = (
    <>
      <span
        className="brief-aud__ic"
        dangerouslySetInnerHTML={{ __html: AUDIENCE_ICONS[audience] }}
      />
      <span className="brief-aud__label">{meta.label}</span>
    </>
  );

  if (!onClick) {
    return (
      <span className={className} title={title ?? meta.gloss}>
        {inner}
      </span>
    );
  }

  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      title={title ?? `${meta.label}. ${meta.gloss} Click to change.`}
      aria-label={`Audience: ${meta.label}. Change`}
    >
      {inner}
    </button>
  );
}
